import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ChevronRight, AlertTriangle } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function IncidenciasLista() {
    const navigate = useNavigate();
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");

    useEffect(() => {
        api.get("/users", { params: { role: "alumno" } })
            .then((r) => setStudents(r.data || []))
            .catch(() => toast.error("Error cargando alumnos"))
            .finally(() => setLoading(false));
    }, []);

    const filtered = students.filter((s) => (s.name || "").toLowerCase().includes(search.toLowerCase()));

    return (
        <div className="p-6 md:p-10 fade-in min-h-screen max-w-2xl mx-auto">
            <h1 className="text-2xl font-semibold mb-1 inline-flex items-center gap-2"><AlertTriangle size={22} className="text-edu-navy" /> Incidencias</h1>
            <p className="text-edu-muted mb-6">Busca al alumno para registrar o revisar sus incidencias.</p>

            <div className="relative mb-4">
                <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-edu-muted" />
                <input
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Buscar alumno por nombre…"
                    className="edu-input w-full pl-9"
                    autoFocus
                />
            </div>

            {loading ? (
                <p className="text-sm text-edu-muted">Cargando…</p>
            ) : filtered.length === 0 ? (
                <div className="edu-card p-8 text-center text-edu-muted">No se encontraron alumnos.</div>
            ) : (
                <div className="space-y-2">
                    {filtered.map((s) => (
                        <button
                            key={s.id}
                            onClick={() => navigate(`/profesor/incidencias/${s.id}`)}
                            className="edu-card w-full text-left p-4 hover:bg-edu-soft transition-colors flex items-center justify-between gap-3"
                        >
                            <div>
                                <p className="font-medium text-sm">{s.name}</p>
                                <p className="text-xs text-edu-muted">{s.grade}</p>
                            </div>
                            <ChevronRight size={16} className="text-edu-muted" />
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
